module.exports = __webpack_public_path__ + "assets/e78f81216e9c5f011cec4bdd3aa1f0aa.mp3";